export default __webpack_public_path__ + "static/media/Polygon.07c31076.svg";